import {
  Divider,
  MenuRow,
  SettingCardRow,
} from '@components/Dashboard/components'
import { Modal, Switch } from '@lib/components'
import type { ID } from '@octopus-do/octopus-project-core'
import type React from 'react'

import type { ModalProps } from '@/types'
import { useProjectNotifications } from './hooks'
import css from './styles.module.css'

interface Props extends ModalProps {
  id: ID
}

// Per-project notification settings (OCT-5229): the account's choice, or an
// override for this project
export const ProjectNotifications: React.FC<Props> = ({ id, onClose }) => {
  const { comments, digest, options, onComments, onDigest } =
    useProjectNotifications(id)

  return (
    <Modal classnames={{ content: css.modal_content }} onClose={onClose}>
      <div className={css.modal_title}>Project notifications</div>
      <div className={css.modal_hint}>Override your account settings</div>
      <div className={css.rows}>
        <MenuRow
          label="Comments"
          description="New comments, mentions and replies"
          value={comments}
          options={options.comments}
          onChange={onComments}
        />

        <Divider />

        <SettingCardRow
          title="Daily summary of changes"
          description="One email a day about edits in the project"
          titleCenter
        >
          <div className={css.toggle}>
            <Switch checked={digest} onChange={onDigest} />
          </div>
        </SettingCardRow>
      </div>
    </Modal>
  )
}
